export const appApiBaseUrl = import.meta.env.VITE_APP_API_BASE_URL;
